/* global $, LP, Boclips */
/* eslint-disable no-var,prefer-rest-params,no-shadow, func-names */
import posthog from 'posthog-js';
import { PH_EVENTS } from 'js/posthog_analytics'

var LpBoclipsVideoHandler = (function () {
  function LpBoclipsVideoHandler() {
    var ref =
      arguments.length > 0 && arguments[0] !== undefined
        ? arguments[0]
        : {
          videoUrl: null,
          user_id: null,
          data: {}
        };
    this.config = LP.config.boclips;
    this.videoUrl = $.trim(String(ref.videoUrl));
    this.user_id = ref.user_id;
    this.data = ref.data || {};
    if (this.config && !this.user_id) {
      this.user_id = this.config.user_id;
    }
    this.videoId = this.getBoclipsId();
    this.player = null;
    this.duration = null;
    this.index = 0;
    if (this.isValidNumber(this.data.i)) {
      this.index = this.data.i;
    }
    if (this.isValidNumber(this.data.clipStart)) {
      this.clipStart = Number(this.data.clipStart);
    }
    if (this.isValidClipEnd(this.data.clipEnd)) {
      this.clipEnd = Number(this.data.clipEnd);
    }
    this.from_rrp = this.data.from_rrp || this.data.from_modal;
    delete this.data.from_rrp;
    delete this.data.from_modal;
    this.hasTrackedPlay = false;
  }

  LpBoclipsVideoHandler.getHandler = function (videoId, index) {
    var players = LpBoclipsVideoHandler.handlers[videoId];
    if (!players || players.length < 1) {
      return null;
    }
    if (/^\d+$/.test(String(index)) && Number(index) >= 0) {
      players = players.filter(function (player) {
        return player.index === index;
      });
    }
    return players[0];
  };

  LpBoclipsVideoHandler.handlers = {};

  LpBoclipsVideoHandler.prototype.isValidNumber = function (nr) {
    return /^\d+$/.test(String(nr)) && Number(nr) >= 0;
  };

  LpBoclipsVideoHandler.prototype.isValidClipEnd = function () {
    if (this.clipStart && Number(this.data.clipEnd) <= this.clipStart) {
      return false;
    }
    return true;
  };

  LpBoclipsVideoHandler.prototype.pause = function () {
    if (this.player) {
      this.player.pause();
    }
  };

  LpBoclipsVideoHandler.prototype.getPlayerUuid = function () {
    var vars = window.location.pathname.split('/');
    var result = null;
    var is_collections_url = vars.length >= 4
      && String(vars[1]).indexOf('collections') > -1
      && String(vars[2]).indexOf('player') > -1

    var is_boclips_metadata_url = vars.length >= 5
      && String(vars[1]).indexOf('boclips') > -1
      && String(vars[2]).indexOf('boclips_video_metadatas') > -1
      && String(vars[3]).indexOf('player') > -1

    if (is_collections_url) {
      return vars[3];
    } else if (is_boclips_metadata_url) {
      return vars[4];
    }
    return result;
  };

  LpBoclipsVideoHandler.prototype.tokenFactory = function () {
    var self = this;
    // eslint-disable-next-line consistent-return
    return new Promise(function (resolve, reject) {
      if (!self.config) {
        return reject(new Error('Not Authorized'));
      }
      var uuid = self.getPlayerUuid();
      var data = { id: self.videoId };
      if (uuid) {
        data.uuid = uuid;
      }
      if (self.from_rrp) {
        data.track = false;
      }
      $.ajax({
        url: self.config.token_path,
        type: 'GET',
        dataType: 'json',
        data,
        success(response) {
          self.user_id = response.user_id;
          self.duration = response.duration;
          if (response.token) {
            return resolve(response.token);
          }
          return reject(new Error('Oh no - not authenticated!'));
        },
        // eslint-disable-next-line no-unused-vars
        error(jqXHR, textStatus, errorThrown) {
          return reject(new Error('Fatal authentication error occurred.'));
        }
      });
    });
  };

  LpBoclipsVideoHandler.prototype.userIdFactory = function () {
    if (String(this.user_id) !== '') {
      return Promise.resolve(this.user_id);
    }
    return undefined;
  };

  LpBoclipsVideoHandler.prototype.apiOptions = function () {
    return {
      tokenFactory: this.tokenFactory.bind(this),
      userIdFactory: this.userIdFactory.bind(this)
    };
  };

  LpBoclipsVideoHandler.prototype.playerControls = function () {
    return [
      'play-large',
      'restart',
      'rewind',
      'play',
      'fast-forward',
      'progress',
      'current-time',
      'duration',
      'mute',
      'volume',
      'captions',
      'settings',
      'fullscreen'
    ];
  };

  LpBoclipsVideoHandler.prototype.interfaceOptions = function () {
    return {
      controls: this.playerControls(),
      addons: {
        seekPreview: {
          frameCount: 20
        },
        hoverPreview: {
          frameCount: 15,
          delayMilliseconds: 200
        },
        singlePlayback: true
      },
      ratio: '4:3'
    };
  };

  LpBoclipsVideoHandler.prototype.analyticsOptions = function () {
    const self = this;
    return {
      metadata: {
        userId: this.user_id
      },
      handleOnSegmentPlayback: (
        video,
        startSeconds,
        endSeconds
      ) => {
        if (!self.hasTrackedPlay) {
          self.hasTrackedPlay = true;
          posthog.capture(PH_EVENTS.SITE.PLAYED_BOCLIPS_VIDEO, { videoId: self.videoId });
        }
      },
    };
  };

  LpBoclipsVideoHandler.prototype.debugEnabled = function () {
    return false;
  };

  LpBoclipsVideoHandler.prototype.getBoclipsId = function () {
    var regExp =
      /(https?:\/\/)?(www.)?api\.(staging-)?boclips.com\/v\d+\/videos\/([^?#/=]+)/;
    var match = this.videoUrl.match(regExp);
    if (match && match[4].length) {
      return match[4];
    }
    return null;
  };

  LpBoclipsVideoHandler.prototype.init = function (container) {
    if (!this.config || !this.config.player_enabled) {
      return;
    }
    const self = this;
    import(/* webpackChunkName: "boclips-player" */ '../player').then((module) => {
      self.destroyExistingPlayer();
      self.player = Boclips.PlayerFactory.get($(container)[0], {
        debug: self.debugEnabled(),
        api: self.apiOptions(),
        analytics: self.analyticsOptions(),
        interface: self.interfaceOptions()
      });
      if (self.player) {
        if (!Array.isArray(LpBoclipsVideoHandler.handlers[self.videoId])) {
          LpBoclipsVideoHandler.handlers[self.videoId] = [];
        }
        LpBoclipsVideoHandler.handlers[self.videoId].push(self);
        // eslint-disable-next-line consistent-return
        return self.player.loadVideo(self.videoUrl, {
          start: self.clipStart,
          end: self.clipEnd
        }).then(() => {
          posthog.capture(PH_EVENTS.SITE.LOADED_BOCLIPS_VIDEO, { videoId: self.videoId });
        });
      }
    });
  };

  LpBoclipsVideoHandler.prototype.destroyExistingPlayer = function () {
    var handler = LpBoclipsVideoHandler.getHandler(this.videoId, this.index);
    if (handler && handler.player) {
      handler.player.destroy();
    }
  };

  return LpBoclipsVideoHandler;
})();

if (LP && LP.module('LpBoclips') && !LP.module('LpBoclips').LpBoclipsVideoHandler) {
  LP.module('LpBoclips').LpBoclipsVideoHandler = LpBoclipsVideoHandler;
} else if (!window.LpBoclipsVideoHandler) {
  window.LpBoclipsVideoHandler = LpBoclipsVideoHandler;
} else if (!window.LpBoclipsVideoHandler) {
  window.LpBoclipsVideoHandler = LpBoclipsVideoHandler;
}
